module.exports = __webpack_public_path__ + "static/media/img.368e6ca0.png";